export const BEGIN_RUN_TIME = new Date().getTime();
